module.exports = __webpack_public_path__ + "static/media/error.64fb6ebe.png";